import React, { CSSProperties, useState } from "react";
import TextPane from "../TextPane/TextPane";
import StyledParagraph from "../StyledParagraph/StyledParagraph";

const helpBtnStyle: CSSProperties = {
    width: 50,
    height: 50,
    borderRadius: '50%',
    border: 'none',
    color: '#eee',
    backgroundColor: '#3aae2a',
    position: 'fixed',
    right: 16,
    bottom: 16,
    filter: 'drop-shadow(2px 4px 6px #aaa)',
    textShadow: '.5px .5px #ccc',
    fontSize: '1.4rem',
    zIndex: 500,
}

const liStyle: CSSProperties = {
    margin: '1rem 0 0',
    paddingLeft: '1.5rem',
}

const TutorialSegment: React.FC = () => {

    const [showTutorial, setShowTutorial] = useState(false);

    return (
        <>
            <button style={helpBtnStyle} onClick={() => setShowTutorial(prevState => !prevState)}>?</button>
            {showTutorial && (
                <TextPane title={"Ukentlig visuell inspeksjon av Ladeanlegget"}>
                    <StyledParagraph Style={{color: '#ccc', fontSize: '0.875rem'}}>
                        visuell sjekk for åpenbare skader
                    </StyledParagraph>
                    <ol style={{margin: '2rem 0 3rem', fontSize: '.9rem', color: '#eee'}}>
                        <li style={liStyle}>Skader på ladekabel eller ladekontakt</li>
                        <li style={liStyle}>Skader på brukergrensesnitt (skjerm, knapper)</li>
                        <li style={liStyle}>Tegn til varmgang (sot-belegg på laderen)</li>
                        <li style={liStyle}>Andre åpenbare skader/feil på lader, takoverbygg, koblingsskap, fundament eller belysning.</li>
                    </ol>
                    <StyledParagraph Style={{color: '#ccc', fontSize: '0.875rem'}}>
                        Eventuelle problemer rapporteres til Ladopp v/Terje Karstensen (48603797).
                    </StyledParagraph>
                </TextPane>
            )}
        </>
    );
}

export default TutorialSegment